import React from 'react';
import { matchPath, useLocation } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Hooks
import { useOrganization } from 'Shared/utils/hooks/use-organization';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useToggle } from 'Shared/utils/hooks';

// Components
import WpBanner from 'Wpds/components/banner/WpBanner';
import { WpButton } from 'Wpds/components/button';
import { WpText } from 'Wpds/components/text';
import { WpIcon } from 'Wpds/components/icon';
import CharmaLegacySunsetModal from '../CharmaLegacySunsetModal/CharmaLegacySunsetModal';

// Styles
import './BannerSunsetLegacyCharma.scss';

const BannerSunsetLegacyCharma = () => {
  const { pathname } = useLocation();
  const { isLoggedIn, user } = useCurrentUser();
  const { isPiOrganization } = useOrganization();
  const { featureFlagEnableCharmaSunsetMessaging } = useFlags();

  const [isOpen, toggleIsOpen] = useToggle(false);
  const isOnboardingRoute = matchPath(pathname, { path: [PageUrlsConstants.ONBOARDING_WIZARD] });

  // don't show if FF is not enabled
  if (!featureFlagEnableCharmaSunsetMessaging) return null;
  // don't show if not logged in
  if (!isLoggedIn) return null;
  // don't show for existing PI orgs
  if (isPiOrganization) return null;
  // don't show if user is still signing up
  if (isOnboardingRoute) return null;
  // don't show if onboarding is not completed
  if (user && !user.onboarding?.completed_at) return null;

  const baseClassName = 'BannerSunsetLegacyCharma';
  return (
    <>
      <WpBanner type="purple">
        <div className={baseClassName}>
          <WpText color="white-0" noMargin>
            <span className={`${baseClassName}__icon`}>
              <WpIcon name="exclamation-circle" />
            </span>
            <WpText color="white-0" noMargin bold tag="span">
              Action required!
            </WpText>{' '}
            Your account will be deactivated March 31, 2025.
          </WpText>

          <div className={`${baseClassName}__btn`}>
            <WpButton size="sm" color="white" onClick={toggleIsOpen}>
              See more details
            </WpButton>
          </div>
        </div>
      </WpBanner>
      {isOpen && <CharmaLegacySunsetModal onDismiss={toggleIsOpen} />}
    </>
  );
};

export default BannerSunsetLegacyCharma;
